// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadError_wrapper_mPxhi","message":"LoadError_message_rumu8","repeatButton":"LoadError_repeatButton_AtgLY"};